import React from 'react';

import { SvgNoise } from '../SvgNoise';

import {
    FixedBackground,
    Interior,
    Layer1,
    Layer2,
    Layer3,
    Layer4,
    Layer5,
    Layer6,
    Layer7,
    SvgNoiseWrapper,
} from './SimpleBlobBg.style';

// TODO: Consider having `noMotion` start at the halfway point of
// the animation, that way we see more color on screen.
export interface SimpleBlobBgProps {
    noise?: boolean;
    noMotion?: boolean;
}

// TODO: This component should run a "hardware capabilities detection"
// and render a static image as a fallback when necessary.
export function SimpleBlobBg({ noise = false, noMotion = false }: SimpleBlobBgProps) {
    const noiseMarkup = noise ? (
        <SvgNoiseWrapper>
            <SvgNoise screen />
        </SvgNoiseWrapper>
    ) : null;

    return (
        <FixedBackground>
            <Interior $noMotion={noMotion}>
                <Layer1 />
                <Layer2 />
                <Layer3 />
                <Layer4 />
                <Layer5 />
                <Layer6 />
                <Layer7 />
            </Interior>

            {noiseMarkup}
        </FixedBackground>
    );
}
